

const TOKEN_KEY = 'token'
const USER_KEY = 'me'

export function setToken(jwt) {
  window.localStorage.setItem(TOKEN_KEY, jwt)
}

export function setMe(user) {
  window.localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function getToken() {
  return window.localStorage.getItem(TOKEN_KEY)
}

export function getMe() {
  return JSON.parse(window.localStorage.getItem(USER_KEY) || 'null')
}

export function isLoggedIn() {
  return getToken()
}

export function logout() {
  window.localStorage.removeItem(TOKEN_KEY)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js